<button #buttonElement
		[type]="type"
		class="button-container"
		[disabled]="disabled"
		[attr.aria-label]="accessibleLabel ? (accessibleLabel | cpActionTranslate | async) : null"
		(click)="clickHandler()">
	<i [class]="iconName" *ngIf="iconName"></i>
	<div class="caption" *ngIf="captionToTranslate && captionToTranslate.length > 0">{{captionToTranslate | cpActionTranslate: translationParameters | async}}</div>
	<ng-content *ngIf="!captionToTranslate"></ng-content>
</button>
